import { isNull } from "App/utils/helpers";

export const handleSortStart = ({ node }) => {
  const tds = document.getElementsByClassName("SortableHelper")[0].childNodes;
  node.childNodes.forEach(
    (node, idx) => (tds[idx].style.width = `${node.offsetWidth}px`)
  );
};

export const defaultState = (id, obj, level, children) => {
  return {
    id: id,
    name: obj.name,
    level: level,
    is_parent: obj.is_parent,
    children: children,
    math: obj.math,
  };
};

export const getIndexStateLevelSatu = (setting_dashboard, parentID) => {
  const oldState = setting_dashboard.filter((x) => x.id === parentID);
  const index = setting_dashboard.findIndex((x) => x.id === parentID);

  return {
    stateLevelSatu: oldState,
    indexLevelSatu: index,
  };
};

export const filterState = (arr, id, type = "add") => {
  if (type === "sort") {
    return arr.filter((x) => x.id !== id);
  } else {
    return arr.filter((x) => x.id === id);
  }
};

export const newStateLevelDua = (
  coaLevelSatu,
  parentIDLevelDua,
  newStateCoa
) => {
  const newStateParentLevelDua = filterState(coaLevelSatu, parentIDLevelDua);
  newStateParentLevelDua[0]["children"] = newStateCoa;
  return newStateParentLevelDua;
};

export const newStateLevelSatu = (setting_neraca, parentIDLevelSatu) => {
  const newStateParentLevelSatu = filterState(
    setting_neraca,
    parentIDLevelSatu
  );
  return newStateParentLevelSatu;
};

export const recursiveAddChildren = (val, arr, children) => {
  arr.forEach((x) => {
    if (x.id === val) {
      x.children.push(children);
    } else {
      if (!isNull(x.children)) recursiveAddChildren(val, x.children, children);
    }
  });
  return arr;
};

export const recursiveChangeChildren = (val, arr, children) => {
  arr.forEach((x) => {
    if (x.id === val) {
      x.children = children;
    } else {
      if (!isNull(x.children))
        recursiveChangeChildren(val, x.children, children);
    }
  });
  return arr;
};

export const convertDate = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
};
